import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppProvider } from './contexts/app-provider';
import { ThemeProvider } from './contexts/theme-context';
import { HelpProvider } from './contexts/HelpContext';
import { HelpPanel } from './components/help/HelpPanel';
import { CommandPalette } from './components/help/CommandPalette';
import { useHelp } from './contexts/HelpContext';
import { GovBanner } from './components/layout/gov-banner';
import { HomePage } from './pages/home';
import { ConfigurationPage } from './pages/configuration';
import { WorkflowsPage } from './pages/workflows';
import { UsersPage } from './pages/users/users-page';
import { PendingApprovalsPage } from './pages/pending-approvals';
import { InApprovalPage } from './pages/in-approval';
import { ApprovedOrdersPage } from './pages/approved-orders';
import { RejectedOrdersPage } from './pages/rejected-orders';
import { SubmittedOrdersPage } from './pages/submitted-orders';
import { PausedOrdersPage } from './pages/paused-orders';
import { NeedsResolvedOrdersPage } from './pages/needs-resolved-orders';
import { OrderDetailPage } from './pages/order-detail';
import { DebugOrderDetailPage } from './pages/debug-order-detail';
import { ProfilePage } from './pages/profile';
import { WorkflowOrderAttributesPage } from './pages/workflow-order-attributes';
import { OrderAttributeDetailPage } from './pages/order-attribute-detail';
import { WorkflowEditPage } from './pages/workflow-edit';
import { WorkflowViewPage } from './pages/workflow-view';
import { WorkflowWizardPage } from './pages/workflow-wizard';
import { CallbackPage } from './pages/callback';
import { SimulatorPage } from './pages/simulator';
import { RegisterPage } from './pages/register';
import { RegisterDivisionPage } from './pages/register-division';
import { DelegationsPage } from './pages/delegations';
import { AllOrdersPage } from './pages/all-orders';
import { WorkflowTemplatesPage } from './pages/workflow-templates';
import { WorkflowApproverReportPage } from './pages/workflow-approver-report';

function HelpComponents() {
  const { isHelpPanelOpen, isCommandPaletteOpen, closeHelpPanel, closeCommandPalette, selectArticle } = useHelp();
  
  return (
    <>
      <HelpPanel isOpen={isHelpPanelOpen} onClose={closeHelpPanel} />
      <CommandPalette 
        isOpen={isCommandPaletteOpen} 
        onClose={closeCommandPalette}
        onArticleSelect={selectArticle}
      />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AppProvider>
        <Router>
          <HelpProvider>
            <div className="App">
              <GovBanner />
              <HelpComponents />
            <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/register/:slug" element={<RegisterDivisionPage />} />
            <Route path="/callback" element={<CallbackPage />} />
            <Route path="/dashboard" element={<HomePage />} />
            <Route path="/action-required" element={<PendingApprovalsPage />} />
            <Route path="/pending-approvals" element={<PendingApprovalsPage />} /> {/* Legacy redirect */}
            <Route path="/in-progress" element={<InApprovalPage />} />
            <Route path="/in-approval" element={<InApprovalPage />} /> {/* Legacy redirect */}
            <Route path="/submitted-orders" element={<SubmittedOrdersPage />} />
            <Route path="/paused-orders" element={<PausedOrdersPage />} />
            <Route path="/completed" element={<ApprovedOrdersPage />} />
            <Route path="/approved-orders" element={<ApprovedOrdersPage />} /> {/* Legacy redirect */}
            <Route path="/cancelled" element={<RejectedOrdersPage />} />
            <Route path="/rejected-orders" element={<RejectedOrdersPage />} /> {/* Legacy redirect */}
            <Route path="/error-queue" element={<NeedsResolvedOrdersPage />} />
            <Route path="/needs-resolved" element={<NeedsResolvedOrdersPage />} /> {/* Legacy redirect */}
            <Route path="/orders/:orderId" element={<OrderDetailPage />} />
            <Route path="/order-detail/:orderId" element={<OrderDetailPage />} />
            <Route path="/debug-order/:orderId" element={<DebugOrderDetailPage />} />
            <Route path="/configuration" element={<ConfigurationPage />} />
            <Route path="/workflow-templates" element={<WorkflowTemplatesPage />} />
            <Route path="/workflow-templates/:divisionId" element={<WorkflowTemplatesPage />} />
            <Route path="/workflows" element={<WorkflowsPage />} />
            <Route path="/workflows/:divisionId" element={<WorkflowsPage />} />
            <Route path="/workflows/:divisionId/new" element={<WorkflowWizardPage />} />
            <Route path="/workflows/:divisionId/:workflowId/view" element={<WorkflowViewPage />} />
            <Route path="/workflows/:divisionId/:workflowId/edit" element={<WorkflowEditPage />} />
            <Route path="/workflows/:divisionId/:workflowId/order-attributes/:fieldId" element={<OrderAttributeDetailPage />} />
            <Route path="/workflows/:divisionId/:workflowId/editable-fields/:fieldId" element={<OrderAttributeDetailPage />} /> {/* Legacy redirect */}
            <Route path="/users" element={<UsersPage />} />
            <Route path="/simulator" element={<SimulatorPage />} />
            <Route path="/simulator/:divisionId" element={<SimulatorPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/delegations" element={<DelegationsPage />} />
            <Route path="/all-orders" element={<AllOrdersPage />} />
            <Route path="/reports/workflow-approvers" element={<WorkflowApproverReportPage />} />
            {/* Add more routes as needed */}
            </Routes>
          </div>
        </HelpProvider>
      </Router>
    </AppProvider>
    </ThemeProvider>
  );
}

export default App;
